import { render, staticRenderFns } from "./CancelButton.vue?vue&type=template&id=3facf7c0&scoped=true&"
import script from "./CancelButton.vue?vue&type=script&lang=js&"
export * from "./CancelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3facf7c0",
  null
  
)

export default component.exports